import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { addToCartApi } from "../api/api";
import CartPopup from "./CartPopup";

export default function ProductDetail({ products, cartItems, setCartItems }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const product = products.find(p => p.id === parseInt(id));
  const [quantity, setQuantity] = useState(1);
  const [showCartPopup, setShowCartPopup] = useState(false);

  if (!product) return <p>Product not found</p>;

  const handleAddToCart = async () => {
    try {
      await addToCartApi(product.id, quantity);

      // Add/update cartItems in state
      const existing = cartItems.find(item => item.id === product.id);
      let updatedCart;
      if (existing) {
        // ✅ Fix: set quantity to the selected value instead of adding each time
        updatedCart = cartItems.map(item =>
          item.id === product.id
            ? { ...item, quantity } // replace quantity with selected one
            : item
        );
      } else {
        updatedCart = [...cartItems, { ...product, quantity }];
      }
      setCartItems(updatedCart);

      setShowCartPopup(true);
    } catch (err) {
      alert("Failed to add to cart");
    }
  };

  return (
    <div style={{ display:"flex", margin:"40px", gap:"40px", position:"relative" }}>
      <img src={product.imageUrl} alt={product.name} style={{ width:"50%", borderRadius:"10px" }} />

      <div style={{ width:"50%", display:"flex", flexDirection:"column", gap:"15px" }}>
        <div style={{ fontSize:"26px", fontWeight:"bold" }}>{product.name}</div>
        <div>{[...Array(5)].map((_,i)=><span key={i} style={{color:"#FFD700"}}>★</span>)}</div>
        <div style={{ display:"flex", gap:"20px", fontSize:"20px" }}>
          <span>₹{product.price}</span>
          <span style={{ color:"#1b7a1b", fontWeight:"bold" }}>{product.discount}% OFF</span>
        </div>

        <div style={{ display:"flex", alignItems:"center", gap:"10px" }}>
          <button onClick={()=>setQuantity(q=>Math.max(1,q-1))}>-</button>
          <span>{quantity}</span>
          <button onClick={()=>setQuantity(q=>q+1)}>+</button>
        </div>

        <button
          style={{ padding:"10px", background:"#1b7a1b", color:"#fff", border:"none", borderRadius:"6px", cursor:"pointer", width:"100%" }}
          onClick={handleAddToCart}
        >
          Add to Cart
        </button>

        <button
          style={{ padding:"10px", background:"#555", color:"#fff", border:"none", borderRadius:"6px", cursor:"pointer", width:"100%", marginTop:"10px" }}
          onClick={()=>navigate(-1)}
        >
          Back
        </button>

        <div style={{ marginTop:"20px", padding:"15px", background:"#f5f5f5", borderRadius:"10px", lineHeight:"1.6", fontSize:"15px", marginLeft:"20px" }}>
          <b>Shipping & Delivery</b> <br/>
          ✈️ Express Shipping: 2-3 Days <br/>
          🚚 Standard Shipping: 4-6 Days <br/>
          🌟 Free Shipping on Orders Over ₹500! <br/>
          🔄 3 Days Easy Replacement Policy <br/>
          📞 WhatsApp/Call: +919322990002 <br/>
          <i>*Timelines are estimates and not guaranteed.</i>
        </div>
      </div>

      {showCartPopup && (
        <CartPopup
          cartItems={cartItems}
          setCartItems={setCartItems}
          onClose={()=>setShowCartPopup(false)}
        />
      )}
    </div>
  );
}
